import { LocalStorageService } from 'angular-2-local-storage';
import { UserLogado } from './userLogado';
import { Injectable } from '@angular/core';

@Injectable()
export class UserLogadoService {

  user: UserLogado = new UserLogado();

  constructor(
    private _localStorage: LocalStorageService
  ) {
    this.carregarDadosUserLogado();
  }

  carregarDadosUserLogado() {

    let user = JSON.parse(localStorage.getItem('currentUserTributos'));

    if (user) {
      this.user.token = user.token;
      this.user.nome = user.nome;
      this.user.cargo = user.cargo;
      this.user.id = user.idusuario;
    }
  }

  validarAcesso(tag){
    let filtrado = this.user.cargo.tags.filter(function(obj){ 
      return obj == tag; 
    });
    if (filtrado.length > 0){
      return true;
    }
    return false;
  }

}
